<template>
  <div>
    <v-snackbar
      v-for="(snackbar, index) in filteredSnackbars"
      :key="index + Math.random().toString(16).slice(2)"
      v-model="snackbar.showing"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      bottom
      :style="`bottom: ${(index * 60) + 30}px`"
    >
      {{ snackbar.text }}
      <template v-slot:action="{ attrs }">
        <v-btn
          text
          v-bind="attrs"
          @click="snackbar.showing = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  props: {
    snackbars: {
      type: Array,
      required: true
    }
  },
  computed: {
    filteredSnackbars() {
      return this.snackbars.filter(s => s.showing);
    }
  }
};
</script>

<style scoped>
</style>
